import { apiClient } from "../components/shared/services/api/axios.config";
import { handleApiError } from "../components/shared/utils/commonApiError";
import {
  UserCreDB,
  UserCreateReq,
  UpdateUserReq,
  CreateUserRes,
  GetUserRes,
} from "../types/user";
import { userDbService } from "./user.storage.service";

class UserService {
  private readonly MAX_ADDRESSES = 5;

  async getLatestUserAndCacheUpdate(userId: string): Promise<UserCreDB | null> {
    try {
      console.log("getLatestUserAndCacheUpdate called, userId:", userId);
      const user: UserCreDB | null = await this.getUserAPI(userId);
      console.log("getLatestUserAndCacheUpdate, user: ", user);
      if (user) {
        await userDbService.saveUser(user);
      }
      return user;
    } catch (error) {
      console.error("[UserService] Failed to get latest user data:", error);
      throw error;
    }
  }

  async getCachedUser(userId: string): Promise<UserCreDB | null> {
    try {
      console.log("getCachedUser called for userId:", userId);
      const user = await userDbService.getUser(userId);
      console.log("getCachedUser result:", user);
      return user;
    } catch (error) {
      console.error("[UserService] Error fetching cached user:", error);
      throw error;
    }
  }

  async getUserAPI(userId: string): Promise<UserCreDB | null> {
    console.log("[UserService] Fetching user details...");

    try {
      console.log("[UserService] Calling get user API...");
      const response = await apiClient.get<GetUserRes>(`/user/${userId}`);

      console.log("[UserService] User details fetched successfully");
      return response.data.data || null;
    } catch (error: any) {
      if (error?.response?.status === 404) {
        console.log("[UserService] No user found, returning null");
        return null; // Return null instead of throwing error for 404
      }
      console.error("[UserService] Failed to fetch user:", error);
      throw handleApiError(error);
    }
  }

  async updateUserData(
    userId: string,
    changes: UpdateUserReq
  ): Promise<CreateUserRes> {
    // Get existing user data
    console.log("[UserService] updateUserData called");
    const existingUser = await this.getCachedUser(userId);
    if (!existingUser) {
      throw new Error("User not found in cache");
    }

    // Create updated user object
    const updatedUser = {
      ...existingUser,
      ...changes,
      updatedAt: new Date().toISOString(),
    };

    console.log("trying to update in backend API");
    // Send to API and update cache
    const apiResponse = await this.updateUserAPI(userId, changes);
    console.log("trying to update in sqlite cache DB");
    await userDbService.saveUser(updatedUser);

    return apiResponse;
  }

  async updateUserAPI(
    userId: string,
    data: UpdateUserReq
  ): Promise<CreateUserRes> {
    console.log("[UserService] updateUserAPI called", {
      userId: userId,
      changes: Object.keys(data),
    });

    try {
      console.log("[UserService] Calling update user API...");
      const response = await apiClient.put<CreateUserRes>(
        `/user/${userId}`,
        data
      );

      console.log("[UserService] User updated successfully");
      return response.data;
    } catch (error) {
      console.error("[UserService] Failed to update user:", error);
      throw handleApiError(error);
    }
  }

  getMaxAddresses(): number {
    console.log("[UserService] getMaxAddresses called");
    return this.MAX_ADDRESSES;
  }
}

export const userService = new UserService();

// export class UserService {
//

//   private dummyUser: UserCreDB = {
//     id: "1234",
//     name: "John Doe",
//     email: "john.doe@example.com",
//     phone: "+919876543210",
//     profileImage: "https://example.com/profile.jpg",
//     location: {
//       currentId: "13",
//       addresses: [
//         {
//           "13": {
//             addressName: "home",
//             locality: "D 202 Aarti Avishkar",
//             city: "Bandar Pakhadi",
//             coordinates: {
//               latitude: 19.2183,
//               longitude: 72.9781,
//             },
//             flatNumber: "D 202",
//             buildingName: "Aarti Avishkar",
//             landmark: "Near Railway Station",
//             contactInfo: {
//               phone: "+919876543210",
//               alternatePhone: "+919876543211",
//             },
//           },
//           "14": {
//             addressName: "work",
//             locality: "Building No 28, Flat No 508",
//             city: "Kandivali West",
//             coordinates: {
//               latitude: 19.2156,
//               longitude: 72.9723,
//             },
//             flatNumber: "508",
//             buildingName: "Building No 28",
//             landmark: "Near Metro Station",
//             contactInfo: {
//               phone: "+919876543212",
//             },
//           },
//         },
//       ],
//     },
//     preferences: {
//       notifications: true,
//       emailUpdates: true,
//       language: "en",
//       currency: "INR",
//     },
//     createdAt: new Date().toISOString(),
//     updatedAt: new Date().toISOString(),
//   };
